<template>
  <div :class="[prefix,`${prefix}-wrap`]">
    <div class="top-menu-container">
      <div class="nav-box full-box">
        <ul class="left-bar">
          <li
            class="not-login"
            v-show="!loginUserInfo.NickName"
          >
            <router-link
              class="menu first"
              to="/login"
            >登录</router-link>
            <router-link
              class="menu"
              to="/SignUp"
            >注册</router-link>
          </li>
          <li
            class="logged"
            v-show="!!loginUserInfo.NickName"
          >
            <Dropdown placement="bottom-end">
              <a
                class="menu first"
                href="javascript:void(0)"
              >
                <span class="username">{{loginUserInfo.NickName}} 您好</span>
                <Icon type="ios-arrow-down"></Icon>
              </a>
              <DropdownMenu slot="list">
                <DropdownItem>
                  <router-link to="/profile/personal">
                    <Icon type="ios-home"></Icon>
                    我的主页
                  </router-link>
                </DropdownItem>
                <DropdownItem> <a
                    class="sign-out"
                    @click="signOutFun"
                  >
                    <Icon type="ios-log-out"></Icon>
                    退出登录
                  </a></DropdownItem>

                <!-- <div class="my-page">
                  <div>

                  </div>
                  <div>

                  </div>

                </div> -->
              </DropdownMenu>
            </Dropdown>
          </li>
          <li class="location">
            <AreaSelection :city="city" :province="province">
              <template v-slot:placeholder="{ currentArea }">
                <span class="icon iconfont iconlocation"></span>
                <span>{{ currentArea.province }}</span>
                <span>{{ currentArea.city }}</span>
              </template>
            </AreaSelection>
          </li>
        </ul>
        <ul class="right-bar">
          <li>
            <Dropdown placement="bottom-start">
              <a
                class="menu first"
                href="javascript:void(0)"
                @click="jumpToPersonalCenter"
              >
                <span class="icon iconfont iconperson"></span>
                个人中心
                <Icon type="ios-arrow-down"></Icon>
              </a>
              <DropdownMenu slot="list">
                <div class="personal-dropdown-menu">
                  <Row type='flex'>
                    <Col>
                    <router-link to="/profile/myOrder?status=all">
                      <span class="icon iconfont iconorder"></span>
                      我的订单
                    </router-link>
                    </Col>

                    <Col>
                    <router-link to="/profile/myFavorite">
                      <span class="icon iconfont iconwishlist"></span>
                      我的收藏
                    </router-link>
                    </Col>
                    <Col>
                    <router-link to="/profile/myOrder?status=pendingPayment">
                      <span class="icon iconfont iconwallet"></span>
                      待付款
                    </router-link>
                    </Col>
                    <Col>
                    <router-link to="/profile/myOrder?status=pendingReceived">
                      <span class="icon iconfont iconpackaged"></span>
                      待收货
                    </router-link>
                    </Col>
                    <Col>
                    <router-link to="/profile/myOrder?status=afterSales">
                      <span class="icon iconfont iconshouhou"></span>
                      售后
                    </router-link>
                    </Col>
                  </Row>
                </div>
              </DropdownMenu>
            </Dropdown>
          </li>
          <li>
            <router-link
              class="menu"
              :to="'/quickOrder'"
            >快速下单</router-link>
          </li>
          <li>
            <Dropdown placement="bottom-start">
              <a
                class="menu"
                href="javascript:void(0)"
              >
                <span class="icon iconfont iconmobile"></span>
                手机商城
                <Icon type="ios-arrow-down"></Icon>
              </a>
              <DropdownMenu slot="list">
                <div class="mobile-app">
                  <div class="qrcode"><img :src="wechatImg"></div>
                  <div class="text">
                    <div>扫一扫,关注鼎阳小程序</div>
                    <div style='color:green'>手机采购,移动办公</div>
                  </div>
                </div>
              </DropdownMenu>
            </Dropdown>
          </li>
          <li>
              <span class="icon iconfont iconphone"></span>
              {{phoneNumber}}
          </li>
          <li>
            <router-link
              class="menu"
              to="/help"
            >帮助中心</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import AreaSelection from '@/components/location/AreaSelection';
import { mapState, mapActions } from 'vuex';
import '@/styles/components/header/topMenu.scss';
import {LocalStorage, StorageName} from '../../utils/storage';
const prefix = 'cpt-top-menu';
export default {
  name: 'TopMenu',
  components: {
    AreaSelection
  },
  data () {
    return {
      prefix,
      province: {},
      city: {},
      phoneNumber: '',
      wechatImg: ''
    };
  },
  computed: {
    ...mapState({
      loginUserInfo: 'loginUserInfo',
      shoppingCart: 'shoppingCart'
    })
  },
  methods: {
    ...mapActions({
      signOut: 'signOut',
      isLogin: 'isLogin',
      getOnlinePhone: 'getOnlinePhone',
      getWxCodeUnlimit: 'getWxCodeUnlimit'
    }),
    goToPay () {
      this.$router.push('/placeOrder');
    },
    myInfo () {
      this.$router.push('/profile');
    },
    signOutFun () {
      this.signOut();
      this.$router.push('/');
    },
    jumpToPersonalCenter () {
      this.$router.push('/profile/personal');
    }
  },
  created () {
    this.isLogin();
    let areaInfo = LocalStorage.getItem(StorageName.areaInfo.areaInfo);
    if (areaInfo) {
      this.province = areaInfo.province;
      this.city = areaInfo.city;
    } else {
      this.province = {
        id: 0,
        name: '请选择'
      };
      this.city = {
        id: 0,
        name: '请选择'
      };
    }
    this.getOnlinePhone().then(res => {
      if (res.Success) {
        this.phoneNumber = res.Data;
      }
    });
    this.getWxCodeUnlimit().then(res => {
      if (res.Success) {
        this.wechatImg = res.Data.ImageUrl;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/TopMenu.vue